import { render, staticRenderFns } from "./IPAdetail.vue?vue&type=template&id=533f2c62&scoped=true"
import script from "./IPAdetail.vue?vue&type=script&lang=js"
export * from "./IPAdetail.vue?vue&type=script&lang=js"
import style0 from "./IPAdetail.vue?vue&type=style&index=0&id=533f2c62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533f2c62",
  null
  
)

export default component.exports